export default "__VITE_ASSET__CeyVvcBJ__"